export async function MountEventRegForm(props: any, el: Element) {
	const a = await import('./EventRegForm');
	a.MountEventRegForm(props, el);
}

(window as any).MountEventRegForm = MountEventRegForm;
